import trainer from '@/api/trainer';
import {
    FETCH_GROUPED_TRAINERS,
    FETCH_TRAINER,
    POST_TRAINER,
    PATCH_TRAINER,
    DELETE_TRAINER,
    WECHAT_UNBIND_TRAINER,
    FETCH_TRAINER_COURSE_MONTHLY_STATS,
} from './types';

export default {
    [FETCH_GROUPED_TRAINERS]({ commit }, payload = {}) {
        const { query } = payload;
        if (query) {
            return trainer
                .search(query)
                .then(resp => commit(FETCH_GROUPED_TRAINERS, resp));
        }

        return trainer
            .grouped()
            .then(resp => commit(FETCH_GROUPED_TRAINERS, resp));
    },
    [FETCH_TRAINER]({ commit }, payload) {
        if (payload.id === 0 && payload.safe) {
            commit(FETCH_TRAINER, null);
            return Promise.resolve();
        }
        return trainer
            .get(payload.id)
            .then(resp => commit(FETCH_TRAINER, resp));
    },
    [FETCH_TRAINER_COURSE_MONTHLY_STATS]({ commit }, payload) {
        commit(FETCH_TRAINER_COURSE_MONTHLY_STATS, null);
        if (payload.id === 0 && payload.safe) {
            return Promise.resolve();
        }
        return trainer
            .getCourseMonthlyStats(payload.id)
            .then(resp => commit(FETCH_TRAINER_COURSE_MONTHLY_STATS, resp));
    },
    [POST_TRAINER]({ commit }, payload) {
        return trainer
            .post(payload.trainer)
            .then(resp => commit(POST_TRAINER, resp));
    },
    [PATCH_TRAINER]({ commit }, payload) {
        return trainer
            .patch(payload.trainer)
            .then(resp => commit(PATCH_TRAINER, resp));
    },
    [DELETE_TRAINER]({ commit }, payload) {
        return trainer
            .delete(payload.id)
            .then(resp => commit(DELETE_TRAINER, resp));
    },
    [WECHAT_UNBIND_TRAINER]({ commit }, payload) {
        return trainer
            .wechatUnbind(payload.id)
            .then(resp => commit(WECHAT_UNBIND_TRAINER, resp));
    },
};



// WEBPACK FOOTER //
// ./src/store/trainer/actions.js